import React from "react";
import { useSpring, animated } from "@react-spring/web";
import { useEffect } from "react";
import "./Project.css";

const ProjectImage = (props) => {
  const [spring, api] = useSpring(
    () => ({
      from: { opacity: 0 },
      config: { duration: 80, tension: 180, friction: 12, mass: 5 },
    }),
    []
  );

  useEffect(() => {
    if (props.isHovered) {
      api.start({
        from: {
          opacity: 0.5,
        },
        to: {
          opacity: 1,
        },
        config: { duration: 400, tension: 180, friction: 12, mass: 5 },
      });
    } else {
      api.start({
        from: {
          opacity: 1,
        },
        to: {
          opacity: 0,
        },
        config: { duration: 400, tension: 180, friction: 12, mass: 5 },
      });
    }
  }, [props.isHovered, api]);

  return (
    <div className="project-image-div" >
      {props.isHovered && (
        <animated.div
          style={{
            ...spring,
            display: "flex",
            marginRight: "36px",
            marginLeft: "-24px",
            objectFit: "cover",
            borderRadius: "16px",
          }}
        >
          <div style={{ display: "flex", overflow: "auto" }}>
            <img alt="" radius="lg" width={"100%"} style={{overflowY: "auto", display: "flex", objectFit: "cover", borderRadius: "16px"}} src={props.hoveredProjectImage} />
          </div> 
        </animated.div>
      )}
    </div>
  );
};

export default ProjectImage;
